export const app = {
    state: {
        card: null,
        contact_email: '',
        employee: null,
        youtube_id: null
    },
    mutations: {
        updateContactEmail(state, email) {
            state.contact_email = email
        },
        updateEmployee(state, employee) {
            state.employee = employee
        },
        updateContentCard(state, card) {
            state.card = card
        },
        updateYoutubeId(state, id) {
            state.youtube_id = id
        },
        updateVideoContent(state, link) {
            state.video_link = link
        }
    },
    actions: {
        init(context) {
            context.commit('updateContactEmail', import.meta.env.VITE_APP_CONTACT_EMAIL)
        },
        updateEmployee(context, employee = null) {
            context.commit('updateEmployee', employee)
        },
        updateContentCard(context, card = null) {
            context.commit('updateContentCard', card)
        },
        updateYoutubeId(context, id = null) {
            context.commit('updateYoutubeId', id)
        },
        updateVideoContent(context, link = null) {
            context.commit('updateVideoContent', link)
        }
    }
}